import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import tokenStorageService from '../helpers/tokenStorageService'

export const PrivateRoute: React.StatelessComponent<any> = ({ component: Component, ...rest }: any) => {
    return <Route {...rest} render={props => (
        tokenStorageService.isUserAuthenticated()
            ? <Component {...props} />
            : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
    )} />

}


// WEBPACK FOOTER //
// ./src/sharedcomponents/privateRoute.tsx